export default __webpack_public_path__ + "static/media/party_popper.f6dc34b7.png";